import React, { useState, useEffect } from "react";
import { collection, getDocs, query, where, deleteDoc } from "firebase/firestore";
import { Helmet, HelmetProvider } from "@dr.pogodin/react-helmet";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import { db } from "../firebaseConfig";
import "../css/App.css";

const Unsubscribe = () => {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Prefill email from query string ?email=...
    useEffect(() => {
        try {
            const params = new URLSearchParams(window.location.search);
            const e = params.get("email");
            if (e) {
                setEmail(e);
            }
        } catch {
            // ignore if window or search params are not available
        }
    }, []);

    const handleChange = (e) => {
        setEmail(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const trimmedEmail = email.trim().toLowerCase();
        if (!trimmedEmail) {
            setStatus("Please enter a valid email address.");
            return;
        }

        setIsSubmitting(true);
        setStatus("Processing your request...");

        try {
            const subsRef = collection(db, "subscribers");
            const q = query(subsRef, where("email", "==", trimmedEmail));
            const snapshot = await getDocs(q);

            if (snapshot.empty) {
                // No matching subscriber found. We still tell the user they are unsubscribed,
                // since they should not receive further emails from this list.
                setStatus(
                    "We couldn't find that email in our list, but you will not receive further messages from us."
                );
            } else {
                // Delete all matching subscriber docs for this email
                const deletions = snapshot.docs.map((docSnap) => deleteDoc(docSnap.ref));
                await Promise.all(deletions);
                setStatus("You've been unsubscribed. We're sorry to see you go.");
            }
        } catch (err) {
            console.error("Error processing unsubscribe:", err);
            setStatus("Something went wrong. Please try again later or contact us directly.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <HelmetProvider>
            <div className="page-wrapper">
                <Helmet>
                    <title>Unsubscribe | SOLE</title>
                </Helmet>
                <Navbar />
                <main className="subscribe-page">
                    <div className="subscribe-hero">
                        <h1>Manage Your Email Preferences</h1>
                        <p>
                            Enter your email address below to unsubscribe from SOLE updates. You will no longer
                            receive meeting reminders, events, or announcements at this address.
                        </p>

                        <form onSubmit={handleSubmit} className="subscribe-form">
                            <input
                                type="email"
                                name="email"
                                placeholder="Email Address"
                                value={email}
                                onChange={handleChange}
                                className="subscribe-input"
                                required
                            />
                            <button type="submit" className="subscribe-button" disabled={isSubmitting}>
                                {isSubmitting ? "Unsubscribing..." : "Unsubscribe"}
                            </button>
                        </form>

                        {status && <p className="subscribe-status">{status}</p>}
                    </div>
                </main>
                <Footer />
            </div>
        </HelmetProvider>
    );
};

export default Unsubscribe;
